import { Component, Input, inject } from '@angular/core';
import { DeploymentItemStatusModel } from '../deployment-status.model';
import { DeploymentFileViewService } from '../../deployment-file-view/deployment-file-view.service';
import { GenerationItemStatus } from '../../generation-status.model';
import { ValidatingHelper } from '../validating.helper';
import _ from 'lodash';

@Component({
    selector: 'adm4-validating-items',
    template: `
    <div class='result-container'>
      @for (item of validationItems; track item) {
        <div class='validation-item'>
          <div class='item-icon-validation-text'>
            @if (shouldDisplaySpinner(item)) {
              <mat-spinner [diameter]='15'></mat-spinner>
            }
            @if (isItemDone(item)) {
              <mat-icon class='validation-item-icon done-icon'>done</mat-icon>
            }
            @if (isItemFailed(item)) {
              <mat-icon class='validation-item-icon error-icon'>error_outline</mat-icon>
            }
            <span class='item-label'>{{item.label}}</span>:
          </div>
          <span class='item-status-text'>{{item.status | lowercase}} {{item?.errorMessage ? '- ' + item?.errorMessage : ''}}</span>
          @if (item.progress) {
            <span class='item-status-progress'>{{item.progress | decimalToPercents}}</span>
          }
          @if (item.currentTask) {
            <span class='item-status-current-task'>: {{item.currentTask}}</span>
          }
          @if (shouldDisplayViewLog(item)) {
            <span class='item-status-log flex-shrink-0'>
              <span>&nbsp;-&nbsp;</span>
              <a (click)="viewLog(item)">view log</a>
            </span>
          }
        </div>
      }
    </div>
    `,
    styleUrls: ['./validating-items.scss'],
    standalone: false
})
export class ValidatingItemsComponent {
  private fileViewer = inject(DeploymentFileViewService);

  @Input() validationItems: DeploymentItemStatusModel[];

  readonly isItemDone = (item: DeploymentItemStatusModel | GenerationItemStatus) => ValidatingHelper.isItemDone(item.status);
  readonly isItemFailed = (item: DeploymentItemStatusModel | GenerationItemStatus) => ValidatingHelper.isItemFailed(item.status);

  shouldDisplaySpinner(item: DeploymentItemStatusModel | GenerationItemStatus): boolean {
    return ValidatingHelper.isItemPending(item.status) || ValidatingHelper.isItemRunning(item.status);
  }

  shouldDisplayViewLog(item: DeploymentItemStatusModel | GenerationItemStatus): boolean {
    return (ValidatingHelper.isItemDone(item.status) || ValidatingHelper.isItemFailed(item.status)) && !_.isNil(item.log);
  }

  viewLog(item: DeploymentItemStatusModel): void {
    this.fileViewer.viewDeploymentStatusModel(item);
  }
}
